import { Modal, Table, Button, Empty } from "antd";
import { useNavigate } from "react-router-dom";
import priceFormat from "../../utils/priceFormat";
import fullDate from "../../utils/fullDate";
import { TABLE_SCROLL } from "../../constants/table";

const MatchedListingsModal = ({
  open,
  onClose,
  title,
  listings,
  companyId,
}) => {
  const navigate = useNavigate();

  const handleViewListing = (listing) => {
    navigate(`/company/${companyId}/agent/listings/${listing._id}/view`);
    onClose();
  };

  const columns = [
    {
      title: "Address",
      key: "address",
      render: (_, record) => (
        <div>
          <div className="font-medium text-black">{record.streetAddr}</div>
          <div className="text-gray-500 text-sm">
            {record.city}, {record.state} {record.zip}
          </div>
        </div>
      ),
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      render: (price) => (
        <span className="font-medium text-black">${priceFormat(price)}</span>
      ),
    },
    {
      title: "Beds/Baths/SqFt",
      key: "details",
      render: (_, record) => (
        <span className="text-black">
          {record.beds} bd • {record.baths} ba • {record.sqFt?.toLocaleString() || "-"} sqft
        </span>
      ),
    },
    {
      title: "Live Date",
      dataIndex: "expiration",
      key: "expiration",
      render: (date) => (
        <span className="text-black">{fullDate(date)}</span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      render: (_, record) => (
        <Button
          type="link"
          className="text-primary p-0"
          onClick={() => handleViewListing(record)}
        >
          View
        </Button>
      ),
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={<span className="text-xl font-semibold">{title}</span>}
      footer={null}
      width={900}
      destroyOnClose
    >
      {listings && listings.length > 0 ? (
        <Table
          scroll={TABLE_SCROLL}
          dataSource={listings}
          columns={columns}
          rowKey="_id"
          pagination={listings.length > 10 ? { pageSize: 10 } : false}
          onRow={(record) => ({
            onClick: () => handleViewListing(record),
            style: { cursor: "pointer" },
          })}
          rowClassName="hover:bg-gray-50 transition-colors"
        />
      ) : (
        <Empty
          description="No matched listings found"
          className="py-8"
        />
      )}
    </Modal>
  );
};

export default MatchedListingsModal;
